import { apiPost, apiGet } from "../../utils"

export function previewContentTransferAdminAPI(data) {
    return apiPost('/api/previewContentTransferAdmin', data)
}

export function contentTransferAdminAPI(data) {
    return apiPost('/api/contentTransferAdmin', data)
}

export function getContentTransferHistoryAdminAPI(filters) {
    const { page = 1, limit = 30 } = filters || {}
    return apiGet(`/api/getContentTransferHistoryAdmin?page=${page}&limit=${limit}`)
}

export function lookupReleaseForTransferAdminAPI(release_id) {
    return apiGet(`/api/lookupReleaseForTransferAdmin?release_id=${release_id}`)
}

export function lookupUserForTransferAdminAPI(user_id) {
    return apiGet(`/api/lookupUserForTransferAdmin?user_id=${user_id}`)
}
